import { Query } from "react-apollo";
import gql from "graphql-tag";
import { AssetVariable, AssetOutput, RentalAdvert, SprocketAsset, SaleAdvert } from "../../../types/types";
import { user_query, assets_query } from "../shared/advertiser_info";

export type AdvertiserInfoAssets = {
  "placeholder_user.png": SprocketAsset
  "google_maps/overview/marker.png": SprocketAsset
}

type QueryVariables = {
  advert_id: number
  assets: AssetVariable<AdvertiserInfoAssets>[]
  locale: string
}


export type QueryResult = {
  sale_advert: SaleAdvert
  assets: AssetOutput<AdvertiserInfoAssets>[]
  siteSettings: {
    googleMapsKey: string
  }
}

export class SaleContentQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query AdvertContent($assets: [AssetInput!]!, $advert_id: ID!, $locale: String) {
      siteSettings {
        googleMapsKey
      }
      sale_advert:saleAdvert(id:$advert_id) {
        type
        referenceNumber
        advertiserFullName
        maintenance
        objectType
        regionOverviewPath
        cityOverviewPath
        departmentOverviewPath
        overviewPath
        skiDistanceTranslation
        longitude
        latitude
        isFreeStanding
        hasSwimmingpool
        onCamping
        hasFireplace
        wheelchairAccessible
        nearBike
        nearGolf
        nearSkiing
        nearHiking
        nearMountainbike
        nearWatersports
        nearMountainsports
        nearFishsport
        nearHorseriding
        nearVillage
        nearCity
        nearForest
        nearCountrySide
        nearMountains
        nearHills
        nearThemepark
        onVineyard
        nearBeach
        nearWater
        nearPublicTransport
        translations(locale:$locale) {
          nodes {
            locale
            skiDistanceText
            buildingState
            locationText
            description
            objectDivision
            details
            terrainBuildings
            remarks
            objectName
          }
        }
        skiArea {
          name
        }
        youtubeUrl
        region {
          id
          name
          staticAbstractMapSvg
          area {
            path
            name
          }
        }
        department {
          id
          name
        }
        city {
          id
          name
        }
        contactPerson {
          id
          telephone1
          telephone2
        }
        ${user_query()}
      }
      ${assets_query()}
    }
  `
}


export const variables = (advert_id: number, locale: string) : QueryVariables => {
  return {
    advert_id: advert_id,
    assets: [
      {
        identifier: "placeholder_user.png"
      },
      {
        identifier: "google_maps/overview/marker.png"
      }
    ],
    locale: locale

  }
}
